exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2i0ttQv1oudSVcln0Nbynz {\n    font-weight: 500;\n    font-family: \"sofia-pro\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n    box-sizing: border-box\n}\n._2i0ttQv1oudSVcln0Nbynz {\n}", ""]);

// exports
exports.locals = {
	"faq": "_2i0ttQv1oudSVcln0Nbynz"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/FAQ/faq.css
 ** module id = 453
 ** module chunks = 0
 **/